/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRequestBody
 */
export interface UpdateRequestBody {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRequestBody
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequestBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequestBody
     */
    proxyId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequestBody
     */
    proxyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequestBody
     */
    sftpUsername: string;
}

/**
 * Check if a given object implements the UpdateRequestBody interface.
 */
export function instanceOfUpdateRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "sftpUsername" in value;

    return isInstance;
}

export function UpdateRequestBodyFromJSON(json: any): UpdateRequestBody {
    return UpdateRequestBodyFromJSONTyped(json, false);
}

export function UpdateRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': json['active'],
        'name': json['name'],
        'proxyId': !exists(json, 'proxy_id') ? undefined : json['proxy_id'],
        'proxyName': !exists(json, 'proxy_name') ? undefined : json['proxy_name'],
        'sftpUsername': json['sftp_username'],
    };
}

export function UpdateRequestBodyToJSON(value?: UpdateRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'name': value.name,
        'proxy_id': value.proxyId,
        'proxy_name': value.proxyName,
        'sftp_username': value.sftpUsername,
    };
}

